import { useTranslation } from "@opendash/i18n";
import { Descriptions } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketTypedMetaField } from "../../../types/TicketMeta";

type Props = {
  meta: TicketTypedMetaField & { type: "boolean" };
};

export const MetaBoolean = observer((props: Props) => {
  const t = useTranslation();

  return (
    <Descriptions.Item label={props.meta.label} key={props.meta.label}>
      {t(
        "maintenance:ticket.meta.boolean." +
          (props.meta.value ? "true" : "false")
      )}
    </Descriptions.Item>
  );
});
